function iconDataURL(svg) {
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
}

const ICONS = {
  alipay: iconDataURL('<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><rect width="1024" height="1024" rx="180" fill="#009fe8"/><path d="M717 438H557V325h198v-70H557V161H449v94H247v70h202v113H283v70h285c-22 47-51 91-86 129-65-28-135-49-208-49-93 0-155 48-163 119-9 80 67 145 176 145 103 0 190-45 263-122 78 34 158 75 252 123 25 13 56 3 68-22l34-69c-95-43-183-82-269-118 42-62 70-131 82-206zM294 776c-58 0-93-28-89-64 4-34 37-55 82-55 46 0 91 11 136 28-42 57-84 91-129 91z" fill="#fff"/></svg>'),
  unionpay: iconDataURL('<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><rect width="1024" height="1024" rx="180" fill="#f7f9fc"/><path d="M226 198h230c39 0 64 31 55 69L394 766c-9 38-48 69-87 69H77c-39 0-64-31-55-69l117-499c9-38 48-69 87-69z" fill="#e33"/><path d="M439 198h250c39 0 64 31 55 69L627 766c-9 38-48 69-87 69H290c-39 0-64-31-55-69l117-499c9-38 48-69 87-69z" fill="#064b93"/><path d="M668 198h230c39 0 64 31 55 69L836 766c-9 38-48 69-87 69H519c-39 0-64-31-55-69l117-499c9-38 48-69 87-69z" fill="#008b8b"/><path d="M323 415h378l-20 82H303zm-45 176h378l-20 82H258z" fill="#fff"/></svg>'),
  bankpay: iconDataURL('<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><rect width="1024" height="1024" rx="180" fill="#1f6feb"/><path d="M190 416h644v350H190z" fill="#fff"/><path d="M142 346l370-172 370 172v62H142z" fill="#fff"/><path d="M254 456h92v250h-92zM466 456h92v250h-92zM678 456h92v250h-92zM164 794h696v74H164z" fill="#1f6feb"/></svg>'),
}

export const PROMOTION_PAYMENT_CHANNELS = [
  { code: 'alipay', label: '支付宝扫码', icon: ICONS.alipay },
  { code: 'unionpay', label: '云闪付', icon: ICONS.unionpay },
  { code: 'bankpay', label: '银行卡支付', icon: ICONS.bankpay },
]

export const PROMOTION_PAYMENT_STATUS_LABELS = {
  created: '待发起支付',
  pending: '待支付',
  processing: '支付处理中',
  paid: '支付成功',
  failed: '支付失败',
  cancelled: '已取消',
  expired: '已过期',
}

export function findPromotionPaymentChannel(code) {
  return PROMOTION_PAYMENT_CHANNELS.find(item => item.code === code) || null
}

export function promotionPaymentStatusLabel(status) {
  return PROMOTION_PAYMENT_STATUS_LABELS[status] || status || '-'
}
